import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { speciesApi } from '../../../../api/speciesLivestockRegistryApi';
import { parseApiError } from './registryHelpers';

export function useSpeciesCatalog(perPage = 1000) {
  const [species, setSpecies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => {
    let active = true;

    const load = async () => {
      setLoading(true);
      setError('');

      try {
        const result = await speciesApi.listAll({ per_page: perPage });
        if (!active) return;
        setSpecies(Array.isArray(result.items) ? result.items : []);
      } catch (err) {
        if (!active) return;
        const message = parseApiError(err, 'Unable to load species catalog.');
        setError(message);
        toast.error(message, { position: 'top-right' });
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      active = false;
    };
  }, [perPage, refreshTick]);

  return {
    species,
    loading,
    error,
    refresh: () => setRefreshTick((value) => value + 1),
  };
}
